import { QueryKey } from "@tanstack/react-query";

export enum QUERY_KEYS {
  CAMPAIGN_CAP_SCHEDULED_CHANGES = "campaign-cap-scheduled-changes",
  AVAILABLE_GENRES = "available-genres",
  AVAILABLE_SUBGENRES = "available-subgenres",
  DISPLAY_MANAGERS = "display-managers",
  APP_RECOMMENDER_TARGETING_BREAKDOWN_EXCHANGES = "app-recommender-targeting-breakdown-exchanges",
  APP_RECOMMENDER_TARGETING_BREAKDOWN_BANNER_SIZE = "app-recommender-targeting-breakdown-banner-size",
  APP_RECOMMENDER_TARGETING_BREAKDOWN_CREATIVE_TYPE = "app-recommender-targeting-breakdown-creative-type",
  CHANGE_HISTORY = "change-history",
  CREATIVE_SNAPSHOT = "creative-snapshot",
  APP_METADATA = "app-metadata",
  CONTENT_RATINGS_FILTER = "content-ratings-filter",
  GENDER_DOMINANCES_FILTER = "gender-dominances-filter",
  TOP_AGE_GROUPS_FILTER = "top-age-groups-filter",
}

export function createQueryKey(key: QUERY_KEYS, ...args: any[]): QueryKey {
  const keys = [key].concat(args);
  const authorization = localStorage.getItem("authorization");

  if (authorization) {
    keys.push(authorization as any);
  }
  // console.log(`[QK]: ${JSON.stringify(keys)}`);
  return keys;
}
